export const googleConfig = {
  clientId: process.env.NEXT_PUBLIC_GOOGLE_OAUTH2_CLIENT_ID || '',
  clientSecret: process.env.NEXT_PUBLIC_GOOGLE_OAUTH2_CLIENT_SECRET || '',
  appCheckSiteKey: process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITE_KEY || ''
};
export default googleConfig;